import { executiveSummaryStore } from './stores.js';
import { SENTIMENT_BASE_URL } from './constants.js';

export function getCurrentDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

export function getParams() {
    const params = new URLSearchParams(window.location.search);

    // Default values
    const defaultKeyword = 'anwar ibrahim';
    const defaultDate = getCurrentDate();

    // Convert the URLSearchParams object to a plain object
    let paramsObj = Array.from(params.entries()).reduce((obj, [key, value]) => {
        obj[key] = value;
        return obj;
    }, {});

    // Set default values for keyword and date if they're not present
    if (!paramsObj.keyword) {
        paramsObj.keyword = defaultKeyword;
    }
    if (!paramsObj.date) {
        paramsObj.date = defaultDate;
    }

    return paramsObj;
}
    
export async function getExecutiveSummary(topTweets) {
    // const response = await fetch(`https://sentiment.graph.gv.my/?tweeturl=${tweet}`);
    const response = await fetch(`${SENTIMENT_BASE_URL}?toptweets=${JSON.stringify(topTweets)}`);
    if (response.ok) {
        const data = await response.json();
        let summary = data.content.replace(/\n/g, '<br />').replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
        executiveSummaryStore.update(() => ({ 
            executiveSummary: summary,
        }));
    } 
}